exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reference-link[data-v-888efca4]{color:#1ab394;cursor:pointer}.reference-link[data-v-888efca4]:focus,.reference-link[data-v-888efca4]:hover{color:#18a689;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-888efca4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotBillableBusiness/NotBillableBusinessList.vue
// module id = 1118
// module chunks = 0